module.exports = __webpack_public_path__ + "components/weather-icon/static/nightthunderstorm-v2-f6fe404576dd452a9353a39f2e80ffa5.svg";